import { IMAGEDOMAIN } from './endpoints';
import { consoleLog } from "./utils";
import { getCompleteRedirectUrl, redirecturl } from "./redirect";

export function bytesToTB(bytes, decimals = 2) {
  try {
    if (bytes === 0 || bytes == 0.0 || bytes == 0.00) {
      return "Bytes";
    }

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return sizes[i];
  } catch (error) {
    return "GB";
  }
}
export const regexNumberTest = word => {
  let validText = word.replace(
    /[`\D~!@#$%^&*()_|+\-=?;•√π÷×¶∆£¢€¥°©®™✓:'",.<> \{\}\[\]\\\/]/g,
    ''
  );
  return validText;
};

export function getPaymentResponsibleValue(data) {
  try {
    if (data?.RatePlanType === 'POSTPAID') {
      if (data.CustomerType == 'B2B' && data.PaymentResponsible == 'X') {
        return 'EPR';
      } else if (data.CustomerType == 'B2B' && data.PaymentResponsible == '') {
        return 'CPR';
      }
    }
  } catch (e) {}
  return '';
}
export function bytesToSize(bytes) {
  let gbValue = (bytes / (1024 * 1024 * 1024)).toFixed(2);
  return gbValue;
}

export function bytesToSizeNew(bytes) {
  if (bytes < 1024) return bytes;
  let i = Math.floor(Math.log(bytes) / Math.log(1024));
  let num = bytes / Math.pow(1024, i);
  // let round = Math.round(num);
  // num = round < 10 ? num.toFixed(2) : round < 100 ? num.toFixed(1) : round;
  // return num;
  let stringValue = num.toFixed(2).toString();
  if (stringValue.endsWith('.00')) {
    return parseInt(stringValue.replace('.00', ''));
  }
  return num.toFixed(2);
}

export function TransFormDashboard(mdata) {
  try {
    // consoleLog('TransFormDashboard', mdata);
    var data = JSON.parse(JSON.stringify(mdata));

    if (
      data != null &&
      data.response != null &&
      data.response.myservices != null &&
      data.response.myservices.length > 0
    ) {
      let _offerdata = [];
      let _offerslist = [];
      for (let a = 0; a < data.response.myservices.length; a++) {
        if (_offerslist.indexOf(data.response.myservices[a].offerid) == -1) {
          _offerslist.push(data.response.myservices[a].offerid);
        }
      }
      for (let a = 0; a < _offerslist.length; a++) {
        let _service = null;
        let _itmservice = data.response.myservices.filter(
          (p) => p.offerid === _offerslist[a]
        );
        if (_itmservice != null) {
          _service = _itmservice[0];
        }
        if (_service != null) {
          _service.balancelist = [];
          for (let b = 0; b < _itmservice.length; b++) {
            let _inner = {
              balance: _itmservice[b].balance,
              dbalance: _itmservice[b].dbalance,
              notation: _itmservice[b].notation + "",
              subofferid: _itmservice[b].subofferid,
              title: _itmservice[b].title,
              daylable: _itmservice[b].daylable,
              days: _itmservice[b].days,
              total: _itmservice[b].total,
              color: _itmservice[b].color,
              isunlimited: _itmservice[b].isunlimited,
              rnlabel: _itmservice[b].rnlabel,
              notation2: _itmservice[b].notation, 
              cbalance: _itmservice[b].balance
            };
            if (_itmservice[b].notation == "Bytes") {
              _inner.notation = bytesToTB(_inner.balance);
              _inner.dbalance = (_inner.dbalance);
              _inner.balance = (_inner.balance);
              _inner.total = (_inner.total);
              _inner.cbalance = ConvertFromBytes(_inner.balance, _inner.notation);
            } else {
              _inner.notation = _itmservice[b].rnnotation;
            }
            _service.balancelist.push(_inner);
          }
          _offerdata.push(_service);
        }
      }

      return _offerdata;
    }
  } catch (e) {
    // console.log("error", e);
  }
  return [];
}

export function TransFormDashboardData(mdata, type) {
  // console.log()
  try {
    var data = JSON.parse(JSON.stringify(mdata));

    if (
      data != null &&
      data.response != null &&
      data.response.myservices != null &&
      data.response.myservices.length > 0
    ) {
      let _offerdata = [];
      let _offerslist = [];
      for (let a = 0; a < data.response.myservices.length; a++) {
        if (_offerslist.indexOf(data.response.myservices[a].offerid) == -1) {
          _offerslist.push({
            offerid: data.response.myservices[a].offerid,
            purchasedate: data.response.myservices[a].purchasedate,
          });
        }
      }
      let _offerslistary = _offerslist.filter(
        (ele, ind) =>
          ind ===
          _offerslist.findIndex(
            elem =>
              elem.offerid === ele.offerid &&
              elem.purchasedate === ele.purchasedate
          )
      );
      _offerslist = _offerslistary;
      for (let a = 0; a < _offerslist.length; a++) {
        let _service = null;
        let _itmservice = data.response.myservices.filter(
          p =>
            p.offerid === _offerslist[a]?.offerid &&
            p.purchasedate === _offerslist[a]?.purchasedate
        );

        if (_itmservice != null) {
          _service = _itmservice[0];
        }
        if (_service != null) {
          _service.balancelist = [];
          for (let b = 0; b < _itmservice.length; b++) {
            let _inner = {
              balance: _itmservice[b].balance,
              dbalance: _itmservice[b].dbalance,
              notation: _itmservice[b].notation + '',
              subofferid: _itmservice[b].subofferid,
              title: _itmservice[b].title,
              daylable: _itmservice[b].daylable,
              days: _itmservice[b].days,
              total: _itmservice[b].total,
              color: _itmservice[b].color,
              isunlimited: _itmservice[b].isunlimited,
              rnlabel: _itmservice[b]?.rnlabel,
              rnnotation: _itmservice[b]?.notation,
              offerqtype: _itmservice[b]?.offerqtype,
              rndsheader: _itmservice[b]?.rndsheader,
              service: _itmservice[b]?.service,
            };
            if (_itmservice[b].notation == 'Bytes') {
              _inner.minvalue = _inner.balance;
              _inner.maxvalue = _inner.total;
              _inner.notation = bytesToTB(_inner.balance);
              _inner.dbalance = bytesToSize(_inner.dbalance);
              _inner.balance = bytesToSizeValue(_inner.balance);
              _inner.totalnotation = bytesToTB(_inner.total);
              _inner.total = bytesToSizeValue(_inner.total);
              const balanceValue = parseFloat(_inner.minvalue);
              const totalValue = parseFloat(_inner.maxvalue);
              if (isNaN(balanceValue) || isNaN(totalValue)) {
                _inner.percentage = ((balanceValue / totalValue) * 100).toFixed(
                  2
                );
              }
              _inner.percentage = ((balanceValue / totalValue) * 100).toFixed(
                2
              );
            } else {
              _inner.notation = _itmservice[b].notation;
              const balanceValue = parseFloat(_inner.balance);
              const totalValue = parseFloat(_inner.total);
              try {
                if (_inner.balance.toString().includes('.')) {
                  let floatValue = parseFloat(_inner.balance);
                  _inner.balance = floatValue.toFixed(2);
                }
                if (_inner.dbalance.toString().includes('.')) {
                  let floatValue = parseFloat(_inner.dbalance);
                  _inner.dbalance = floatValue.toFixed(2);
                }
                if (_inner.total.toString().includes('.')) {
                  let floatValue = parseFloat(_inner.total);
                  _inner.total = floatValue.toFixed(2);
                }
                if (isNaN(balanceValue) || isNaN(totalValue)) {
                  _inner.percentage = (
                    (balanceValue / totalValue) *
                    100
                  ).toFixed(2);
                }
                _inner.percentage = ((balanceValue / totalValue) * 100).toFixed(
                  2
                );
              } catch (error) {}
            }

            _service.balancelist.push(_inner);
          }
          if (type === 'dashboard') {
            _service.balancelist.sort((a, b) =>
              a.position > b.position ? 1 : -1
            );
          }
          _offerdata.push(_service);
        }
      }
      // console.log('_offerdata', _offerdata);
      return _offerdata;
    }
  } catch (e) {
    consoleLog('error', e);
  }
  return [];
}

export function gamificationBanners(data) {
  let cirlcetemp = [];
  try {
    if (data !== null && data.length > 0) {
      let _circlebanneritems = data[0];
      if (
        _circlebanneritems != null &&
        _circlebanneritems.cards != null &&
        _circlebanneritems.cards.length > 0
      ) {
        for (let a = 0; a < _circlebanneritems.cards.length; a++) {
          let _circlebitem = JSON.parse(
            JSON.stringify(_circlebanneritems.cards[a])
          );
          if (
            _circlebitem.imageurl != null &&
            _circlebitem.imageurl !== undefined &&
            _circlebitem.imageurl.length > 10
          ) {
            cirlcetemp.push(_circlebitem);
          }
        }
      }
    }
  } catch (e) {}
  return cirlcetemp;
}
export function GetMobileNo(msisdn) {
  try {
    if (msisdn.length == 11 && msisdn.indexOf("965") == 0) {
      return msisdn.substring(3);
    }
  } catch (e) {}
  return msisdn;
}
export function ConvertFromBytes(value, convertTo) {
  if (typeof value !== "number") {
    value = parseInt(value);
  }
  if (convertTo === "TB" || convertTo === "Unlimited") {
    return (value / (1024 * 1024 * 1024 *1024)).toFixed(2);
  }
  else if (convertTo === "GB") {
    return (value / (1024 * 1024 * 1024)).toFixed(2);
  } else if (convertTo === "MB") {
    return (value / (1024 * 1024)).toFixed(2);
  } else if (convertTo === "KB") {
    return (value / 1024).toFixed(2);
  }
  else if (convertTo.toString().toLowerCase() === "bytes") {
    return (value / (1024 * 1024 * 1024)).toFixed(2);
  }
}

export function convertStringToNumber(val) {
  try {
    if (val != null && val != undefined) {
      return Number(val);
    } else {
      return 0;
    }
  } catch (e) {
    return 0;
  }
}

export function MathRound(val) {
  try {
    let val1 = Math.round(val * 100) / 100;
    if (val1 != null && val1 != undefined) {
      return val1;
    }
  } catch (e) {}
  return val;
}

// export const replaceAll = (str, mapObj) => {
//   var re = new RegExp(Object.keys(mapObj).join('|'), 'gi');

//   return str.replace(re, function (matched) {
//     return mapObj[matched];
//   });
// };

export const replaceAll = (str, mapObj) => {
  // Ensure mapObj is an object
  if (typeof mapObj !== 'object' || mapObj === null) {
      throw new Error('mapObj must be an object');
  }

  // Escape special characters in keys to prevent injection
  const escapedKeys = Object.keys(mapObj).map(key => key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));

  // Create a regular expression with escaped keys
  const re = new RegExp(escapedKeys.join('|'), 'gi');

  // Replace occurrences of keys with corresponding values
  return str.replace(re, matched => mapObj[matched]);
};

export function isIOSDevice() {
  return (
    !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
  );
}

export function isAppleDevice() {
  return (
    !!navigator.platform && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)
  );
}

export function isHuaweiDevice() {
  // const userAgent = navigator.userAgent.toLowerCase();
  // return /huawei/i.test(userAgent);
  return false;
}

export const areObjectsEqual = (firstObj, secondObj) => {
  return JSON.stringify(firstObj) === JSON.stringify(secondObj);
};

	//CPR Number
  export function isB2BCPRNumber(data) {
    try {
      if (data.CustomerType == 'B2B' && data.PaymentResponsible == '') {
        return 'B2BCPR';
      }
    } catch (e) {}
    return null;
  }

  export function removeClassByID(elementID, classname) {
    var element = document.getElementById(elementID);
    element.classList.remove(classname);
  }

  export function getformatedMsisdn(msisdn) {
    if(msisdn && msisdn.length == 11){
      return msisdn.substring(3);
    }else{
      return msisdn;
    }
  }

  export function getImgSrc(path, isServerUrl){
    if(path){
      if(isServerUrl){
        if(path.includes('https://') || path.includes('http://')){
          return path;
        }else{
          return `${IMAGEDOMAIN + path}`
        }
      }else{
        return `${process.env.PUBLIC_URL}${path}` 
      }
    }
    return ''
  } 

  export function groupByPaymentOptions(objectArray, property) {
    return objectArray.reduce((acc, obj) => {
       const key = obj[property];
       if (!acc[key]) {
          // acc[key] = [];
          acc[key] = {
            cat: obj['category'],
            catLabel: obj['categorytitle'],
            list: []
          };
       }
       // Add object to list for given key's value
      //  acc[key].push(obj);
       acc[key].list.push(obj);
       return acc;
    }, {});
 }
  export function bytesToSizeValue(bytes) {
    if (bytes < 1024) return bytes;
    let i = Math.floor(Math.log(bytes) / Math.log(1024));
    let num = bytes / Math.pow(1024, i);
    const formatted =  num.toFixed(2);
    return parseFloat(formatted);
  }

  export const setLangInLocalStorage = (lang) => {
    localStorage.setItem('lang', lang);
  }

  export function generateDashboardLayout(data, numberOfRows) {
    let temp = [];
    try {
      if (data !== null && data != undefined && data.length > 0) {
        var dataAry = [];
        var voiceAry = [];
        var smsAry = [];
        var oVoiceAry = [];
        for (let a = 0; a < data.length; a++) {
          if (
            data[a]?.rnnotation != null &&
            data[a]?.rnnotation != undefined &&
            data[a]?.rnnotation != '' &&
            data[a]?.notation != null &&
            data[a]?.notation != undefined &&
            data[a]?.notation != ''
          ) {
            if (data[a]?.rnnotation === 'Bytes') {
              dataAry.push(data[a]);
            } else if (
              data[a]?.notation === 'Min' &&
              data[a]?.service.toUpperCase() === 'OOREDOO'
            ) {
              oVoiceAry.push(data[a]);
            } else if (data[a]?.rnnotation === 'Units') {
              smsAry.push(data[a]);
            } else {
              voiceAry.push(data[a]);
            }
          }
          // var item = [];
          // for (let b = 0; b < numberOfRows; b++) {
          //   if (a + b < data.length) {
          //     item.push(data[a + b]);
          //   }
          // }
          // temp.push(item);
          // a += numberOfRows;
        }
  
        var newdataAry = [];
        var newdata1Ary = [];
        for (let i = 0; i < dataAry.length; i++) {
          if (dataAry[i]?.service !== 'Internet') {
            var obj = dataAry[i];
            newdataAry.push(obj);
          } else {
            var obj = dataAry[i];
            newdata1Ary.push(obj);
          }
        }
        dataAry = newdata1Ary.concat(newdataAry);
  
        var newsmsAry = [];
        var newsms1Ary = [];
        for (let i = 0; i < smsAry.length; i++) {
          if (smsAry[i]?.service !== 'Local') {
            var obj = smsAry[i];
            newsmsAry.push(obj);
          } else {
            var obj = smsAry[i];
            newsms1Ary.push(obj);
          }
        }
        smsAry = newsms1Ary.concat(newsmsAry);
  
        for (let a = 0; a < data.length; a++) {
          if (
            dataAry.length > 0 ||
            smsAry.length > 0 ||
            voiceAry.length > 0 ||
            oVoiceAry.length > 0
          ) {
            if (dataAry.length > 0 && voiceAry.length > 0) {
              temp.push([dataAry[0], voiceAry[0]]);
              dataAry = dataAry.slice(1);
              voiceAry = voiceAry.slice(1);
            } else if (voiceAry.length > 0 && smsAry.length > 0) {
              temp.push([voiceAry[0], smsAry[0]]);
              voiceAry = voiceAry.slice(1);
              smsAry = smsAry.slice(1);
            } else if (dataAry.length > 0 && smsAry.length > 0) {
              temp.push([dataAry[0], smsAry[0]]);
              dataAry = dataAry.slice(1);
              smsAry = smsAry.slice(1);
            } else if (dataAry.length > 1) {
              temp.push([dataAry[0], dataAry[1]]);
              dataAry = dataAry.slice(1);
              dataAry = dataAry.slice(1);
            } else if (voiceAry.length > 1) {
              temp.push([voiceAry[0], voiceAry[1]]);
              voiceAry = voiceAry.slice(1);
              voiceAry = voiceAry.slice(1);
            } else if (smsAry.length > 1) {
              temp.push([smsAry[0], smsAry[1]]);
              smsAry = smsAry.slice(1);
              smsAry = smsAry.slice(1);
            } else if (dataAry.length > 0 && oVoiceAry.length > 0) {
              temp.push([dataAry[0], oVoiceAry[0]]);
              dataAry = dataAry.slice(1);
              oVoiceAry = oVoiceAry.slice(1);
            } else if (voiceAry.length > 0 && oVoiceAry.length > 0) {
              temp.push([voiceAry[0], oVoiceAry[0]]);
              voiceAry = voiceAry.slice(1);
              oVoiceAry = oVoiceAry.slice(1);
            } else if (smsAry.length > 0 && oVoiceAry.length > 0) {
              temp.push([smsAry[0], oVoiceAry[0]]);
              smsAry = smsAry.slice(1);
              oVoiceAry = oVoiceAry.slice(1);
            } else if (dataAry.length > 0) {
              temp.push([dataAry[0]]);
              dataAry = dataAry.slice(1);
            } else if (voiceAry.length > 0) {
              temp.push([voiceAry[0]]);
              voiceAry = voiceAry.slice(1);
            } else if (smsAry.length > 0) {
              temp.push([smsAry[0]]);
              smsAry = smsAry.slice(1);
            } else if (oVoiceAry.length > 1) {
              temp.push([oVoiceAry[0], oVoiceAry[1]]);
              oVoiceAry = oVoiceAry.slice(1);
              oVoiceAry = oVoiceAry.slice(1);
            } else if (oVoiceAry.length > 0) {
              temp.push([oVoiceAry[0]]);
              oVoiceAry = oVoiceAry.slice(1);
            }
          }
        }
      }
    } catch (e) {
      consoleLog(e);
    }
    return temp;
  }

  export function generateLineDetails(data) {
    try {
      if (data != null) {
        for (let a = 0; a < data.Services.length; a++) {
          if (
            data.Services[a].changed == null ||
            data.Services[a].changed == undefined
          ) {
            if (data.Services[a].notation == 'Bytes') {
              data.Services[a].notation = 'GB';
              data.Services[a].minvalue = data.Services[a].balance;
              data.Services[a].maxvalue = data.Services[a].total;
              data.Services[a].rnnotation = bytesToTB(data.Services[a].balance);
              data.Services[a].rntotalnotation = bytesToTB(
                data.Services[a].total
              );
              data.Services[a].dbalance = bytesToSize(data.Services[a].dbalance);
              data.Services[a].balance = bytesToSize(data.Services[a].balance);
              data.Services[a].total = bytesToSize(data.Services[a].total);
            } else if (data.Services[a].notation == 'Min') {
              data.Services[a].notation = data.Services[a].notation;
              data.Services[a].rnnotation = data.Services[a].notation;
              data.Services[a].rntotalnotation = data.Services[a].notation;
            } else {
              data.Services[a].notation = data.Services[a].notation;
              data.Services[a].rnnotation = data.Services[a].rnnotation;
              data.Services[a].rntotalnotation = data.Services[a].rnnotation;
            }
            data.Services[a].changed = '1';
          }
        }
      }
    } catch (e) {}
    return data;
  }
  const isCompleteUrl = (url) =>{
    return (url.includes('http://') || url.includes('https://'));
  }

  export const handleRemoteUrl = (url, isExternal, navigate, navigateData) => {
    //open in new tab
    if(isExternal){
      // if complete url i.e with http or https
      if(isCompleteUrl(url)){
        window.open(url, "_blank");
        //if internal page link
      }else{
        const internalCompleteRedirectUrl = getCompleteRedirectUrl(url, isExternal ,navigate)
        window.open(internalCompleteRedirectUrl, "_blank");
      }

    //open in current tab
    }else{
      // if complete url i.e with http or https
      if(isCompleteUrl(url)){
        window.open(url, "_self");
      //if internal page link
      }else{
        if(navigateData){
          redirecturl(url, navigate, null, null, navigateData);
        }else{
          redirecturl(url, navigate);
        }
      }
    }
  }

  export const isDevEnv = () => {
    return !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
  }

  export const getMilliseconds = (seconds) => {
    if(isNaN(seconds)){
      return 2000;
    }else{
      return seconds * 1000;
    }
  }

 export const isContainArabicCharacters = (text) => {
    let regex = new RegExp("[\u0600-\u06ff]|[\u0750-\u077f]|[\ufb50-\ufc3f]|[\ufe70-\ufefc]");
    return regex.test(text);
 }

 export const groupBy = (items, key) => items.reduce(
  (result, item) => ({
    ...result,
    [item[key]]: [
      ...(result[item[key]] || []),
      item,
    ],
  }), 
  {},
);

export const compareMonths = (fromMonth, toMonth) => {
  const monthNames = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
  const fromIndex = monthNames.indexOf(fromMonth);
  const toIndex = monthNames.indexOf(toMonth);

  return fromIndex <= toIndex;
}

export const getMonthsDiff = (fromMonth, toMonth) => {
  const monthNames = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
  const fromIndex = monthNames.indexOf(fromMonth);
  const toIndex = monthNames.indexOf(toMonth);

  return (toIndex - fromIndex) + 1;
}

export function getLastMonths(count) {
  const today = new Date();
  const months = [];

  for (let i = 0; i < count; i++) {
      let month = today.getMonth() - i;
      let year = today.getFullYear();
      if (month < 0) {
          month += 12;
          year--;
      }
      const monthNumber = (month + 1);
      // months.push({ month: getMonthName(monthNumber), monthNumber, year });
      months.push({ month: getMonthName(monthNumber), monthNumber: monthNumber?.toString()?.padStart(2, '0'), year: year.toString() });
  }

  return months.reverse(); // Reversing the array to get the months in descending order
}

function getMonthName(monthNumber) {
  const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
  ];
  return months[monthNumber - 1];
}

export function isToMonthGreaterThanFromMonth(fromMonth, toMonth) {
  if (toMonth.year > fromMonth.year) {
      return true;
  } else if (toMonth.year === fromMonth.year) {
      return toMonth.monthNumber >= fromMonth.monthNumber;
  } else {
      return false;
  }
}

export function monthDifference(fromMonth, toMonth) {
  const fromYear = fromMonth.year;
  const toYear = toMonth.year;
  const fromMonthNumber = fromMonth.monthNumber;
  const toMonthNumber = toMonth.monthNumber;

  return (toYear - fromYear) * 12 + (toMonthNumber - fromMonthNumber);
}

export function getUniqueObjects(array) {
  const uniqueObjects = new Set();
  array.forEach(obj => {
      uniqueObjects.add(JSON.stringify(obj));
  });
  return Array.from(uniqueObjects).map(obj => JSON.parse(obj));
}

export function getCurrentMonthObject() {
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const currentDate = new Date();
  const month = months[currentDate.getMonth()];
  const monthNumber = String(currentDate.getMonth() + 1).padStart(2, '0');
  const year = String(currentDate.getFullYear());

  return {
      "month": month,
      "monthnumber": monthNumber,
      "year": year
  };
}